export const CHANGE_DIALOG_STATUS = "dialogReducer/CHANGE_DIALOG_STATUS";
